export default __webpack_public_path__ + "static/SR China - General Conditions of Sales-74cbf9ab215ab69b95073ccd38fefcb1.pdf";